<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.employee_type_name" :error="form.errors.employee_type_name"
                        class="pb-8 pr-6 w-full lg:w-1/1" label="Name Of Type" placeholder="i.e Permanent"
                        @keyup="slugBuild" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Name of Slug" required="true" placeholder="i.e permanent" />
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Type Status"
                        class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create
                        Type</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, inject, toRefs } from 'vue'
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton
    },
    layout: Layout,
    remember: 'form',

    setup() {
        const form = useForm({
            employee_type_name: null,
            slug: null,
            status: true
        })
        const type = ref('create')
        const title = ref('Employee Type')
        const url = ref('/backend/employeetypes')
        const createUrl = ref('')
        const swal = inject('$swal')
        const store = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(`${url.value}`, { forceFormData: true, })
                    swal.fire(
                        'Added!',
                        'Your infomation has been Added.',
                        'success'
                    )
                }
            });

        }
        const slugBuild = () => {
            form.slug = form.employee_type_name.replace(/\s/g, '-').toLowerCase()
        }
        return {
            form,
            type,
            title,
            url,
            createUrl,
            store,
            slugBuild
        }
    }

}
</script>
